module.exports = {
  getRatingForPoints(points, numberOfQuestions, maxRating) {
    if (points === 0) {
      // no answer correct
      return 0;
    } else if (points === numberOfQuestions) {
      // all answers correct
      return maxRating;
    } else {
      // a number between 1 and maxRating - 1
      return Math.ceil((maxRating - 1) * points / numberOfQuestions)
    }
  }
}